import Typography from '@mui/material/Typography';
import { FC, ReactNode } from 'react';

export const ConfirmModalTitle: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Typography variant="h2" sx={(theme) => ({ marginBottom: theme.spacing(2) })}>
      {children}
    </Typography>
  );
};
